import { TConditionalComponentProps } from './conditionalComponent.types';

function ConditionalComponent({ condition, whenTrue, whenFalse }: TConditionalComponentProps) {
  return condition ? whenTrue : whenFalse;
}

export default ConditionalComponent;
